import { rem } from 'polished';

import { baseFontSize } from '@braindate/ui/lib/token/typography';

export default {
  alert: {
    fontWeight: 400,
    '& .MuiAlert-action': {
      position: ({ isCentered }: Record<string, any>) =>
        isCentered ? 'absolute' : 'unset',
      right: ({ isCentered }: Record<string, any>) =>
        isCentered ? 10 : 'unset',
    },
    '& .MuiButtonBase-root': {
      minWidth: 'auto',
      minHeight: 'auto',
    },
    justifyContent: ({ isCentered }: Record<string, any>) =>
      isCentered ? 'center' : 'normal',
  },
  message: {
    fontSize: rem(16, baseFontSize),
  },
  link: {
    fontSize: rem(16, baseFontSize),
    fontWeight: 700,
    textDecoration: 'underline',
    textAlign: 'left',
  },
  icon: {
    alignItems: 'center',
  },
  checkIcon: {
    fontSize: '0.7em',
  },
  text: {
    margin: 0,
  },
};
